import axios from "axios";
import { API_BASE_URL } from "../config/config";

// const currentDomain = window.location.hostname; // Örn: "localhost" veya "www.example.com"
// // https://apis.aiconnect.com.tr/activityboard/getExtensions
// // API URL'sini dinamik olarak ayarlamak
// const API_BASE_URL = (currentDomain === 'localhost' || currentDomain === '127.0.0.1' || currentDomain === 'aiconnect.com.tr'  || currentDomain === 'demo.aiconnect.com.tr' )
//   ? 'https://apis.aiconnect.com.tr/activityboard'
//   : `https://apis.${currentDomain}/activityboard`;

const AgentBreakLogService = {
  getExtension: (data) => {
    const params = new URLSearchParams({
      token: data.token,
      accountcode: data.accountcode,
      userid: data.userid,
    });
    return axios.get(
      `${API_BASE_URL}/activityboard/getExtension?${params.toString()}`
    );
  },
  getExtensions: (data) => {
    return axios.post(`${API_BASE_URL}/activityboard/getExtensions`, data);
  },
};

export default AgentBreakLogService;
